import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { AxsButtonComponent } from '@vanguard/axs-angular';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';
import { environment } from 'src/environments/environment';

import { AdobeLaunchService } from '../../adobe-launch/adobe-launch.service';

export interface ProductCardsContent {
  productHeader: string;
  productTitle1: string;
  productDesc1: string;
  productButton1: string;
  productTitle2: string;
  productDesc2: string;
  productButton2: string;
  productTitle3: string;
  productDesc3: string;
  productButton3: string;
}

@Component({
  selector: 'product-cards',
  standalone: true,
  imports: [CommonModule, AxsButtonComponent],
  templateUrl: './product-cards.component.html',
  styleUrls: ['./product-cards.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductCardsComponent implements OnInit {
  productCardsContent = content.Data.v4_rcc_root.content
    .productCards as unknown as ProductCardsContent;
  productLinks = {
    modelPortfolios: `${environment.advisorsBaseUrl}/portfolio-construction-tools/model-portfolios/`,
    equityInvestments: `${environment.advisorsBaseUrl}/investments/all?asset_class=Equity`,
    personalizedIndexing: `${environment.advisorsBaseUrl}/investments/personalized-indexing`,
  };

  constructor(
    private readonly contentService: ContentService,
    private readonly adobeLaunchService: AdobeLaunchService,
  ) {}

  ngOnInit(): void {
    this.contentService.getContent().subscribe((data) => {
      this.productCardsContent = data.Data.v4_rcc_root.content
        .productCards as unknown as ProductCardsContent;
    });
  }

  public adobeTaggingCTAEvent(ctaName: string): void {
    this.adobeLaunchService.captureAction(ctaName, 'button');
  }
}
